module.exports = __webpack_public_path__ + "img/PO.e1b3ac4b.png";